export default {
	is_active_attr: 'data-is-active',
	disabled_attr: 'disabled',
	hidden_attr: 'hidden',
	
	load_e: 'load',
	error_e: 'error',
	click_e: 'click',
	change_e: 'change',
	input_e: 'input',
	key_down_e: 'keydown',
	key_up_e: 'keyup',
	mouse_over_e: 'mouseover',
	mouse_out_e: 'mouseout',
	mouse_enter_e: 'mouseenter',
	mouse_leave_e: 'mouseleave',
	mouse_move_e: 'mousemove',
	focus_e: 'focus',
	blur_e: 'blur',
	submit_e: 'submit',
	scroll_e: 'scroll',
	resize_e: 'resize',
	transition_end_e: 'transitionend',
	play_e: 'playing',
	pause_e: 'pause',
	ended_e: 'ended',
	before_print_e: 'beforeprint',
	
	true_s: 'true',
	false_s: 'false',

	reveal_attr: 'reveal',
	revealing_attr: 'revealing',
	revealed_attr: 'revealed',

	// This is here to avoid circular dependencies
	datepicker_$: '.air-datepicker',
}
